export default "__VITE_ASSET__faacd01b__"